/**
 * Leaf constants for hotel cancellation refund reason values.
 * Kept out of HotelCancellationReason.tsx so api/order can validate reasons
 * without importing the React modal (and the analytics ↔ order cycle).
 */

export const OTHER_OPTION = 'Other (please specify)'
export const CHEAPER_OPTION = 'Found a cheaper deal'

export const REFUND_REASONS: Array<string> = [
  CHEAPER_OPTION,
  'Change in travel plans',
  'Personal reasons',
  'Financial constraints',
  'Travel restrictions',
  'Better loyalty program or rewards',
  OTHER_OPTION,
]
